import { render, staticRenderFns } from "./orderInfor.vue?vue&type=template&id=20575cf9&scoped=true&"
import script from "./orderInfor.vue?vue&type=script&lang=js&"
export * from "./orderInfor.vue?vue&type=script&lang=js&"
import style0 from "./orderInfor.vue?vue&type=style&index=0&id=20575cf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20575cf9",
  null
  
)

export default component.exports